import Immutable from 'seamless-immutable';
import _ from 'lodash';

/**
 * AccountApiData
 * Currently is used just for a few additional (secure) properties, because we can not replace globalConfig account data with the data received from the backend,
 * as it is used in many places across the app and we want to avoid unexpected issues with that.
 * @typedef {Object} AccountApiDataModel
 * @property {string} privateApikey - the private API key for the account, this is a secure value that is not included in the main account data
 */

/**
 * Create an AccountApiDataModel from provided data
 * @param {Object} account - the account as a POJO
 */
function create(account) {
  return Immutable(account);
}

/**
 * Transform a backend account object into a frontend AccountApiDataModel
 * @param {Object} account - backend formatted account
 * @returns {AccountApiDataModel}
 */
function deserialize(account) {
  const result = _.pick(account, _keys);
  return create(result);
}

const _keys = ['privateApikey'];

const _defaultAccount = {};

export default {
  create,
  deserialize,
};
